import React, { useState } from 'react';
import { useFormik } from 'formik';
import { useDeposit } from 'providers';
import { PhotoFormView } from 'components/Photo/PhotoFormView';
import { MAX_FILE_SIZE } from 'utils/files';
import { useReturn } from 'hooks';
import { useMountEffect } from 'hooks/use-mount-effect';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'routes';
import { Tracking } from 'api';

export const PhotoForm: React.FC = () => {
  const history = useHistory();
  const { pictures, setPictures, setDepositPictures } = useDeposit();
  const [errorMessage, setErrorMessage] = useState('');
  const { values, setFieldValue, isSubmitting, handleSubmit } = useFormik({
    enableReinitialize: true,
    initialValues: { files: pictures ?? [] },
    onSubmit: async values => {
      if (values.files) {
        try {
          await setPictures(values.files);
        } catch (e) {
          setErrorMessage((e as Error).message);
          Tracking.sendCurrentPageError();
          return;
        }
      }
      history.push(ROUTES.contactInformation);
    },
  });

  useMountEffect(() => {
    (async () => {
      const classifiedReference = localStorage.getItem('classifiedReference');
      const classifiedPictures = localStorage.getItem(`${classifiedReference}-awsPictures`);

      if (classifiedPictures) {
        await setDepositPictures();
      }
    })();
  });

  const handleReturn = useReturn(ROUTES.vehicleDescription);

  return (
    <PhotoFormView
      values={values}
      setFieldValue={setFieldValue}
      max={50}
      maxFileSize={MAX_FILE_SIZE}
      isSubmitting={isSubmitting}
      onReturn={handleReturn}
      handleSubmit={handleSubmit}
      errorMessage={errorMessage}
    />
  );
};
